module.exports = __webpack_public_path__ + "static/creand-logo-f81bb4b1f50081ae5f4b8265903a1fac.png";